(function () {
  function init(root) {
  if (!root || root._shipDone) return; root._shipDone = true;
  var cutoff = +root.getAttribute('data-cutoff') || 17, freeOver = +root.getAttribute('data-free-over') || 0, isBundle = root.getAttribute('data-bundle') === 'true';
  var price = (+root.getAttribute('data-price') || 0) / 100;
  var lMin = +root.getAttribute('data-lead-min') || 2, lMax = +root.getAttribute('data-lead-max') || 6;
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function melNow() {
    var f = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false });
    var o = {}; f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return new Date(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute);
  }
  function addBiz(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function shipDate() {
    var n = melNow(), wd = n.getDay(), biz = wd !== 0 && wd !== 6, before = n.getHours() < cutoff;
    /* business day before the cut-off: ships the next business day. After it: the business day after that. Weekends: next business day */
    var steps = biz ? (before ? 1 : 2) : 1;
    return { d: addBiz(n, steps), left: biz && before ? Math.max(0, cutoff * 60 - (n.getHours() * 60 + n.getMinutes())) : 0, early: biz && before };
  }
  var sd = shipDate(), line = root.querySelector('[data-ship-line]'), eta = null;
  var h = Math.floor(sd.left / 60), m = sd.left % 60;
  line.innerHTML = (sd.early ? 'Order in the next <b>' + (h ? h + 'h ' : '') + m + 'm</b> and it ships ' : 'Order now and it ships ') + '<b>' + fmt(sd.d) + '</b>.';
  /* calculator */
  var goBtn = root.querySelector('[data-ship-go]'); if (!goBtn) return;
  /* Real rates (AUD) from the store's shipping profile: [one candle, two or more candles or a bundle] */
  var EU = 'AL AD AT AX BA BE BG BY CH CZ DE DK EE ES FI FO FR GG GI GR HR HU IM IS IT JE LI LT LU LV MC MD ME MK MT NL NO PL PT RO RS RU SE SI SJ SK SM UA VA XK'.split(' ');
  var ROW = 'AE AF AG AI AM AR AW AZ BB BH BL BM BO BQ BR BS BZ CL CO CR CW CY DM DO EC FK GD GE GF GL GP GS GT GY HN HT IL IQ JM JO KG KN KW KY KZ LB LC MF MQ MS MX NI OM PA PE PK PM PS PY QA SA SR SV SX TC TJ TL TM TR TT UY UZ VC VE VG YE'.split(' ');
  var RATES = {
    AU: { std: [9.99, 0, '2 to 6'], exp: [16.95, 19.95, '1 to 3'] },
    NZ: { std: [17.95, 22.95, '8 to 12'], exp: [23.95, 27.95, '4 to 8'] },
    UK: { std: [34.95, 55.95, '6 to 10'], exp: [46.95, 50.95, '4 to 8'] },
    CA: { std: [31.95, 49.95, '6 to 10'], exp: [42.95, 46.95, '3 to 7'] },
    EU: { std: [43.95, 70.95, '8 to 12'], exp: [53.95, 59.95, '6 to 10'] },
    ROW: { std: [49.95, 79.95, '8 to 12'], exp: [63.95, 70.95, '6 to 10'] }
  };
  function zone(c) { if (c === 'AU' || c === 'NZ' || c === 'CA') return c; if (c === 'GB' || c === 'IE') return 'UK'; if (EU.indexOf(c) > -1) return 'EU'; if (ROW.indexOf(c) > -1) return 'ROW'; return ''; }
  function cur(aud) {
    try { var C = window.Shopify && Shopify.currency; if (C && C.active && C.active !== 'AUD') { var v = aud * (parseFloat(C.rate) || 1); return new Intl.NumberFormat(undefined, { style: 'currency', currency: C.active }).format(v) + ' ' + C.active; } } catch (e) {}
    return '$' + aud.toFixed(2) + ' AUD';
  }
  var out = root.querySelector('[data-ship-out]');
  root.querySelector('[data-ship-go]').addEventListener('click', function () {
    var c = root.querySelector('[data-ship-country]').value, z = zone(c), R = RATES[z];
    var setEl = document.querySelector('input[name="pdp-set"]:checked'), multi = isBundle || (setEl && setEl.value !== 'single') || root.getAttribute('data-multi') === 'true';
    out.innerHTML = '';
    if (!R) { out.innerHTML = '<li><span>' + 'We do not currently ship to that country. Email help@donteatmycandle.com and we will let you know when we do.' + '</span></li>'; out.hidden = false; return; }
    [['Standard', R.std], ['Express', R.exp]].forEach(function (m) {
      var r = m[1], p = multi ? (r[1] || r[0]) : r[0], free = (z === 'AU' && m[0] === 'Standard' && multi);
      var days = r[2].split(' to '), a = addBiz(sd.d, +days[0]), b = addBiz(sd.d, +days[1]);
      var li = document.createElement('li'); if (free) li.className = 'is-free';
      li.innerHTML = '<span>' + m[0] + '<small>Arrives ' + fmt(a) + ' to ' + fmt(b) + '</small></span><b>' + (free ? 'FREE' : cur(p)) + '</b>';
      out.appendChild(li);
    });
    out.hidden = false;
  });
  }
  window.demcShip = init;
  Array.prototype.forEach.call(document.querySelectorAll('[data-ship]'), init);
})();
